import Vue from 'vue'
import Router from 'vue-router'

import { requireAuth } from './guard'

Vue.use(Router)
import Layout from '@/views/Layout'

export const constantRouterMap = [
	{
		path: '',
		redirect: '/dashboard',
		component: Layout,
		children: [
			{
				path: 'login',
				beforeEnter: (to, from, next) => requireAuth(to, from, next, false),
				component: () => import('@/views/Login')
			},
			{
				path: 'dashboard',
				beforeEnter: (to, from, next) => requireAuth(to, from, next, true),
				component: () => import('@/views/Dashboard')
			}
		]
	}, {
		path: '*', redirect: '/'
	}
]

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({ y: 0 }),
	routes: constantRouterMap
})
